import { render, staticRenderFns } from "./HookItem.vue?vue&type=template&id=42483554&scoped=true&"
import script from "./HookItem.vue?vue&type=script&lang=js&"
export * from "./HookItem.vue?vue&type=script&lang=js&"
import style0 from "./HookItem.vue?vue&type=style&index=0&id=42483554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42483554",
  null
  
)

export default component.exports